import React from 'react';

import './card.scss';

const Card = ({ title, description, url }) => {
  return (
    <a
      href={url}
      className="card"
    >
      <div className="card2">
        <p>{title}</p>
      </div>
    </a>
  );
};

export default Card;
